import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class PlanoRecrutamentoService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllPlanoRecrutamento`,
      this.getParams(params),
      true
    );
  }
  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getPlanoRecrutamentoById/${id}`,
      this.getParams(),
      true
    );
  }
  add(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddPlanoRecrutamento`,
      data,
      {},
      true
    );
  }
  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdatePlanoRecrutamento`,
      data,
      this.getParams(),
      true
    );
  }

  updateEstado(
    id: number,
    planoRecrutamentoEstadoEnum: number,
    motivoPlanoRecrutamentoEstado: string | null = null
  ): Observable<any> {
    return this.apiService.put(
      `${this.path}/${id}/Estado`,
      {
        planoRecrutamentoEstadoEnum,
        motivoPlanoRecrutamentoEstado,
      },
      this.getParams(),
      true
    );
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeletePlanoRecrutamentoById/${id}`,
      this.getParams(),
      true
    );
  }

  downloadTemplateEmpresaSector(empresaId: number): Observable<Blob> {
    return this.apiService.download(
      `${this.path}/SubmeterPdrh/template-empresa-sector/${empresaId}`,
      new HttpParams(),
      {},
      true
    );
  }

  importarNecessidades(empresaId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.apiService.post(
      `${this.path}/SubmeterPdrh/importar-empresa-sector/${empresaId}`,
      formData,
      {},
      true
    );
  }

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
